import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./css/adminnegocompleteproduct.css";
import { getNegoHistory, searchNegoHistory } from "../../utils/adminProductService";
import { downloadNegoHistoryExcel } from "../../utils/adminExcelService";
import { formatDateTime24 } from "../../utils/commonService";
import Pagination from "../common/Pagination";

const AdminNegoCompleteProduct = () => {
  const navigate = useNavigate();

  const [histories, setHistories] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const pageSize = 10;

  const [filters, setFilters] = useState({
    startDateFrom: "",
    startDateTo: "",
    endDateFrom: "",
    endDateTo: "",
    searchType: "all",
    searchKeyword: "",
  });

  const [isSearchMode, setIsSearchMode] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);

  useEffect(() => {
    loadHistories();
  }, []);

  const loadHistories = async (page = 0) => {
    const result = await getNegoHistory(page, pageSize);
    if (result.success) {
      setHistories(result.data.content);
      setCurrentPage(result.data.number);
      setTotalPages(result.data.totalPages);
      setTotalElements(result.data.totalElements);
      setIsSearchMode(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    isSearchMode ? handleSearchInternal(page) : loadHistories(page);
  };

  const handleSearchInternal = async (page = 0) => {
    const result = await searchNegoHistory(
      {
        startDateFrom: filters.startDateFrom,
        startDateTo: filters.startDateTo,
        endDateFrom: filters.endDateFrom,
        endDateTo: filters.endDateTo,
        searchType: filters.searchType,
        searchTerm: filters.searchKeyword,
      },
      page,
      pageSize
    );
    if (result.success) {
      setHistories(result.data.content);
      setCurrentPage(result.data.number);
      setTotalPages(result.data.totalPages);
      setTotalElements(result.data.totalElements);
      setIsSearchMode(true);
    } else {
      alert(result.error);
    }
  };

  const handleSearch = () => {
    setCurrentPage(0);
    handleSearchInternal(0);
  };

  const handleReset = () => {
    setFilters({ startDateFrom: "", startDateTo: "", endDateFrom: "", endDateTo: "", searchType: "all", searchKeyword: "" });
    setCurrentPage(0);
    loadHistories(0);
  };

  return (
    <div className="adminnegocompleteproduct-container">
      <div className="adminnegocompleteproduct-wrap">
        <div className="adminnegocompleteproduct-tab-navigation">
          <button
            className="adminnegocompleteproduct-tab-button"
            onClick={() => navigate("/admin/product/nego")}
          >네고 진행 목록</button>
          <button
            className="adminnegocompleteproduct-tab-button adminnegocompleteproduct-tab-active"
          >네고 완료 목록</button>
        </div>

        <div className="adminnegocompleteproduct-filter-wrap">
          <div className="adminnegocompleteproduct-filter-row">
            <div className="adminnegocompleteproduct-filter-group">
              <label>시작일시 기준</label>
              <input
                type="date"
                className="adminnegocompleteproduct-date-input"
                value={filters.startDateFrom}
                onChange={(e) => setFilters({ ...filters, startDateFrom: e.target.value })}
              />
              <span>~</span>
              <input
                type="date"
                className="adminnegocompleteproduct-date-input"
                value={filters.startDateTo}
                onChange={(e) => setFilters({ ...filters, startDateTo: e.target.value })}
              />
            </div>
          </div>
          <div className="adminnegocompleteproduct-filter-row">
            <div className="adminnegocompleteproduct-filter-group">
              <label>종료일시 기준</label>
              <input
                type="date"
                className="adminnegocompleteproduct-date-input"
                value={filters.endDateFrom}
                onChange={(e) => setFilters({ ...filters, endDateFrom: e.target.value })}
              />
              <span>~</span>
              <input
                type="date"
                className="adminnegocompleteproduct-date-input"
                value={filters.endDateTo}
                onChange={(e) => setFilters({ ...filters, endDateTo: e.target.value })}
              />
            </div>
          </div>

          <div className="adminnegocompleteproduct-filter-row adminnegocompleteproduct-search-row">
            <div className="adminnegocompleteproduct-search-group">
              <select
                className="adminnegocompleteproduct-select-type"
                value={filters.searchType}
                onChange={(e) => setFilters({ ...filters, searchType: e.target.value })}
              >
                <option value="all">전체</option>
                <option value="productNm">상품명</option>
                <option value="storeNm">가맹점명</option>
              </select>
              <input
                type="text"
                placeholder="검색어를 입력해주세요."
                className="adminnegocompleteproduct-input"
                value={filters.searchKeyword}
                onChange={(e) => setFilters({ ...filters, searchKeyword: e.target.value })}
              />
              <button className="adminnegocompleteproduct-button-search-btn" onClick={handleSearch}>검색</button>
              <button className="adminnegocompleteproduct-button-reset-btn" onClick={handleReset}>초기화</button>
            </div>
          </div>
        </div>

        <div className="adminnegocompleteproduct-table-wrap">
          <div className="adminnegocompleteproduct-table-header">
            <div className="adminnegocompleteproduct-table-header-text">
              총 <span className="adminnegocompleteproduct-count">{totalElements}</span>건
            </div>
            <button
              className="adminnegocompleteproduct-excel-btn"
              onClick={async () => {
                setExcelLoading(true);
                const result = await downloadNegoHistoryExcel();
                setExcelLoading(false);
                if (!result.success) alert(result.error);
              }}
              disabled={excelLoading}
            >
              {excelLoading ? "다운로드 중..." : "엑셀 다운로드"}
            </button>
          </div>
          <table className="adminnegocompleteproduct-table">
            <thead>
              <tr>
                <th>가맹점</th>
                <th>상품명</th>
                <th>원가</th>
                <th>상태</th>
                <th>시작일시</th>
                <th>종료일시</th>
              </tr>
            </thead>
            <tbody className="adminnegocompleteproduct-table-body">
              {histories.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    네고 내역이 없습니다.
                  </td>
                </tr>
              ) : (
                histories.map((item, index) => (
                  <tr key={item.negoLogIdx}>
                    <td>{item.storeNm}</td>
                    <td>{item.productNm}</td>
                    <td>{item.price?.toLocaleString()}원</td>
                    <td>{item.negoLogStatus === "COMPLETED" ? "완료" : "취소"}</td>
                    <td>{formatDateTime24(item.startDateTime)}</td>
                    <td>{formatDateTime24(item.endDateTime)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};
export default AdminNegoCompleteProduct;